import { useTranslation } from 'react-i18next';
export const useCharacterAlignmentTypes = () => {
    const { t } = useTranslation();
    return [
        { value: 'lawful_good', label: t('character.alignments.lawful_good') },
        { value: 'neutral_good', label: t('character.alignments.neutral_good') },
        { value: 'chaotic_good', label: t('character.alignments.chaotic_good') },
        { value: 'lawful_neutral', label: t('character.alignments.lawful_neutral') },
        { value: 'true_neutral', label: t('character.alignments.true_neutral') },
        { value: 'chaotic_neutral', label: t('character.alignments.chaotic_neutral') },
        { value: 'lawful_evil', label: t('character.alignments.lawful_evil') },
        { value: 'neutral_evil', label: t('character.alignments.neutral_evil') },
        { value: 'chaotic_evil', label: t('character.alignments.chaotic_evil') },
    ];
};
